export default function PatientConsent() {
  return (
    <div style={{ maxWidth: 720, margin: '0 auto', padding: '3rem 1.5rem', fontFamily: 'sans-serif', color: '#111827', lineHeight: 1.7 }}>
      <h1 style={{ fontSize: 28, fontWeight: 700, marginBottom: 4 }}>Your Rights and What to Expect</h1>
      <p style={{ color: '#6b7280', fontSize: 14, marginBottom: '2rem' }}>Last Updated: May 13, 2026</p>
      <p>Your physical therapist has invited you to use this app to view your rehabilitation program and track your progress. Before you get started, please take a few minutes to read this — it explains what the app does, what we collect, and your rights as a user.</p>

      <hr style={{ border: 'none', borderTop: '1px solid #e5e7eb', margin: '2rem 0' }} />

      <h2 style={{ fontSize: 18, fontWeight: 700, marginBottom: 8 }}>What This App Does</h2>
      <p>This app lets your physical therapist:</p>
      <ul style={{ paddingLeft: '1.5rem' }}>
        <li>Send you a personalized exercise or rehabilitation program</li>
        <li>Assign specific exercises with instructions</li>
        <li>See when you've marked exercises as complete</li>
      </ul>
      <p>It does <strong>not</strong> replace your physical therapist's care, and we do not provide any medical advice or treatment recommendations.</p>

      <h2 style={{ fontSize: 18, fontWeight: 700, margin: '2rem 0 8px' }}>Your Physical Therapist Is Your Clinician — Not Us</h2>
      <p>We are a software tool, not a healthcare provider. Your physical therapist is responsible for your care, your program, and any clinical decisions. If you have questions about your exercises, feel pain or discomfort, or want to change your program, contact your physical therapist directly.</p>
      <p><strong>If you have a medical emergency, call 911.</strong></p>

      <h2 style={{ fontSize: 18, fontWeight: 700, margin: '2rem 0 8px' }}>What Information We Collect</h2>
      <p>When you create an account, we collect:</p>
      <ul style={{ paddingLeft: '1.5rem' }}>
        <li>Your name and email address</li>
        <li>A password (stored securely and never visible to us)</li>
      </ul>
      <p>When you use the app, we collect:</p>
      <ul style={{ paddingLeft: '1.5rem' }}>
        <li>Which exercises you've been assigned</li>
        <li>When you mark exercises as complete</li>
      </ul>
      <p>We do <strong>not</strong> collect your diagnosis, medical history, insurance information, or payment details.</p>

      <h2 style={{ fontSize: 18, fontWeight: 700, margin: '2rem 0 8px' }}>Who Can See Your Information</h2>
      <ul style={{ paddingLeft: '1.5rem' }}>
        <li><strong>Your physical therapist</strong> can see your assigned program and your completion activity</li>
        <li><strong>We</strong> can see your account information for the purpose of running the app</li>
        <li>We do <strong>not</strong> sell your information to third parties</li>
        <li>We do <strong>not</strong> share your information with advertisers</li>
      </ul>

      <h2 style={{ fontSize: 18, fontWeight: 700, margin: '2rem 0 8px' }}>This App Is in Beta</h2>
      <p>We are still building and testing this app. This means:</p>
      <ul style={{ paddingLeft: '1.5rem' }}>
        <li>Features may change</li>
        <li>You may encounter bugs or errors</li>
        <li>We may occasionally need to take the service offline</li>
      </ul>
      <p>We recommend keeping any important instructions your PT gives you saved somewhere outside the app as a backup.</p>

      <h2 style={{ fontSize: 18, fontWeight: 700, margin: '2rem 0 8px' }}>Your Choices and Rights</h2>
      <p><strong>You can stop using the app at any time.</strong> Simply stop logging in — your account will remain inactive.</p>
      <p><strong>You can request your account be deleted.</strong> Email us at <a href="mailto:support@completept.app" style={{ color: '#6366f1' }}>support@completept.app</a> and we will delete your account and associated data within 30 days.</p>
      <p><strong>You can ask what data we have about you.</strong> Email us and we'll send you a summary.</p>

      <h2 style={{ fontSize: 18, fontWeight: 700, margin: '2rem 0 8px' }}>A Note for Parents and Guardians</h2>
      <p>If your child is under 18 and has been invited to use this app, a parent or guardian must review and agree to these terms on their behalf before they create an account. By accepting the invite, you confirm that you are the parent or legal guardian and consent to your child's participation.</p>

      <h2 style={{ fontSize: 18, fontWeight: 700, margin: '2rem 0 8px' }}>Changes to This Document</h2>
      <p>If we make significant changes to how the app works or how we handle your data, we'll notify you by email before those changes take effect.</p>

      <h2 style={{ fontSize: 18, fontWeight: 700, margin: '2rem 0 8px' }}>Questions?</h2>
      <p>If you have any questions about the app or this document, contact us at:</p>
      <p>CompletePT<br /><a href="mailto:support@completept.app" style={{ color: '#6366f1' }}>support@completept.app</a></p>
      <p>If you have questions about your rehabilitation program, contact your physical therapist directly.</p>
    </div>
  )
}
